export default function DoubleGridContent({ children }) {
  return (
    <section className="block mt-12 lg:mt-24">
      <div className="olafGrid xl:max-w-7xl grid lg:grid-cols-2 gap-12">
        {children}
      </div>
    </section>
  );
}
